<template>

    <div id="lt_lyrics">


        <h3 class="subtitle">מילים</h3>
        <ul>
            <li v-for="song in item.songs" :key="song">
                <!-- <a href="lnk_download/song?sid={{this.id}}" download="{{this.name}}"{{/is_br_logged}}></a> -->
                <h3 :style="`${isHeb(song.lyrics) ? '' : 'direction: rtl; text-align: right;'}`" v-text="song.name"></h3>
                <div :style="`${isHeb(song.lyrics) ? '' : 'direction: rtl; text-align: right;'}`" class="content" v-html="song.lyrics"></div>

            </li>

        </ul>


    </div>
</template>

<script>

export default {
  props: ["item"],
  data(){
    return {
    }
  },
  mounted(){
  },
  methods: {

  }
}
</script>